import InstanceApi from "@/services/apiClient.js";
import { mapGetters, mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["setWizardInfoDataRequired", "setWizardInfoDataRequired"]),
    async selectSlot() {
      try {
        let apiUrlSelectSlot = "mcp/cart/selectSlot?";
        // ADD PREPEND DATA KEY
        Object.keys(this.preprendCartDataDelivery)
          .filter(i => i !== "mcp_intervention_product")
          .filter(i => i !== "mcp_additional_sku")
          .forEach(key => {
            if (this.preprendCartDataDelivery[key] !== "") {
              apiUrlSelectSlot = `${apiUrlSelectSlot}${key}=${this.preprendCartDataDelivery[key]}&`;
            }
          });
        apiUrlSelectSlot = `${apiUrlSelectSlot}product=${this.productId}&mcp_intervention_date_updated=1`;
        this.setWizardInfoDataRequired({
          type: "postalcode",
          data: this.preprendCartDataDelivery.mcp_intervention_zipcode,
        });

        const response = await InstanceApi.get(apiUrlSelectSlot);
        
        if (response.status && response.status === 200) {
          // in async so not in other method
          let gtmDataFormat = "product";
          if(window.McpGtm) McpGtm.pushCustomDataLayer('calendar', {}, { calendar: this.preprendCartDataDelivery.mcp_intervention_date + " | " + this.preprendCartDataDelivery.mcp_intervention_slot }, gtmDataFormat);
          return response.data;
        }
        
      } catch (error) {
        console.error(error);
        this.$fire({
          title: "Oups",
          text: "Une erreur est survenu lors du choix du créneau",
          type: "error",
          timer: 1500,
          position: "top-end",
        });
      }
    },

  },

  computed: {
    ...mapGetters({
      preprendCartDataDelivery: "getPreprendCartDeliveryData",
      productId: "getProductId",
    }),
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),
  }
};
